import { useTranslation } from 'react-i18next'

import { Region } from '../types/Region'

export const useMarketsByRegions = () => {
  const { t } = useTranslation()

  return {
    [Region.Asia]: {
      name: t('common:region_asia'),
      marketIsos: [
        'af',
        'am',
        'az',
        'bh',
        'bd',
        'bt',
        'bn',
        'kh',
        'cn',
        'cy',
        'ge',
        'hk',
        'in',
        'id',
        'ir',
        'iq',
        'il',
        'jp',
        'jo',
        'kz',
        'kp',
        'kr',
        'kw',
        'kg',
        'la',
        'lb',
        'mo',
        'my',
        'mv',
        'mn',
        'mm',
        'np',
        'om',
        'pk',
        'ps',
        'ph',
        'qa',
        'sa',
        'sg',
        'lk',
        'sy',
        'tw',
        'tj',
        'th',
        'tl',
        'tr',
        'tm',
        'ae',
        'uz',
        'vn',
        'ye',
      ],
    },
    [Region.Europe]: {
      name: t('common:region_europe'),
      marketIsos: [
        'ax',
        'al',
        'ad',
        'at',
        'by',
        'be',
        'ba',
        'bg',
        'hr',
        'cz',
        'dk',
        'ee',
        'fo',
        'fi',
        'fr',
        'de',
        'gi',
        'gr',
        'gg',
        'va',
        'hu',
        'is',
        'ie',
        'im',
        'it',
        'je',
        'lv',
        'li',
        'lt',
        'lu',
        'mt',
        'md',
        'mc',
        'me',
        'nl',
        'mk',
        'no',
        'pl',
        'pt',
        'ro',
        'ru',
        'sm',
        'rs',
        'sk',
        'si',
        'es',
        'sj',
        'se',
        'ch',
        'ua',
        'gb',
      ],
    },
    [Region.Africa]: {
      name: t('common:region_africa'),
      marketIsos: [
        'dz',
        'ao',
        'bj',
        'bw',
        'io',
        'bf',
        'bi',
        'cv',
        'cm',
        'cf',
        'td',
        'km',
        'cg',
        'cd',
        'ci',
        'dj',
        'eg',
        'gq',
        'er',
        'sz',
        'et',
        'tf',
        'ga',
        'gm',
        'gh',
        'gn',
        'gw',
        'ke',
        'ls',
        'lr',
        'ly',
        'mg',
        'mw',
        'ml',
        'mr',
        'mu',
        'yt',
        'ma',
        'mz',
        'na',
        'ne',
        'ng',
        're',
        'rw',
        'sh',
        'st',
        'sn',
        'sc',
        'sl',
        'so',
        'za',
        'ss',
        'sd',
        'tz',
        'tg',
        'tn',
        'ug',
        'eh',
        'zm',
        'zw',
      ],
    },
    [Region.Oceania]: {
      name: t('common:region_oceania'),
      marketIsos: [
        'as',
        'au',
        'cx',
        'cc',
        'ck',
        'fj',
        'pf',
        'gu',
        'hm',
        'ki',
        'mh',
        'fm',
        'nr',
        'nc',
        'nz',
        'nu',
        'nf',
        'mp',
        'pw',
        'pg',
        'pn',
        'ws',
        'sb',
        'tk',
        'to',
        'tv',
        'um',
        'vu',
        'wf',
      ],
    },
    [Region.Americas]: {
      name: t('common:region_americas'),
      marketIsos: [
        'ai',
        'ag',
        'ar',
        'aw',
        'bs',
        'bb',
        'bz',
        'bm',
        'bo',
        'bq',
        'bv',
        'br',
        'ca',
        'ky',
        'cl',
        'co',
        'cr',
        'cu',
        'cw',
        'dm',
        'do',
        'ec',
        'sv',
        'fk',
        'gf',
        'gl',
        'gd',
        'gp',
        'gt',
        'gy',
        'ht',
        'hn',
        'jm',
        'mq',
        'mx',
        'ms',
        'ni',
        'pa',
        'py',
        'pe',
        'pr',
        'bl',
        'kn',
        'lc',
        'mf',
        'pm',
        'vc',
        'sx',
        'gs',
        'sr',
        'tt',
        'tc',
        'us',
        'uy',
        've',
        'vg',
        'vi',
      ],
    },
  }
}
